import getDecodedUserId from "@/helpers/get-decoded-user-id";

/**
 * SIP user part for Merapi WebRTC registration.
 * Prefer `user.agent_id` (PBX / inbound routing often uses this); else decoded platform user id.
 */
export function getSipLineExtension() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem("user");
    if (!raw) return null;
    const user = JSON.parse(raw);
    if (user?.agent_id != null && String(user.agent_id).trim() !== "") {
      return String(user.agent_id).trim();
    }
    const decoded = getDecodedUserId();
    if (decoded != null && String(decoded).trim() !== "") {
      return String(decoded).trim();
    }
    return null;
  } catch {
    return null;
  }
}
